import styled from "styled-components";

export const FooterBottom = styled.div`
  background: #000;
  padding: 50px 0 60px;
`;

export const LandingContainer = styled.div`
  width: 1200px;
  margin: 0 auto;
  display: flex;
  color: #ffffff;
  align-items: center;
`;

export const CopyrightContainer = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: column;
  text-align: right;
  justify-content: flex-end;
`;

export const CopyrightText = styled.p`
  margin-bottom: 5px;
  font-weight: 700;
  font-size: calc(var(--font-scale, 1) * 16px);
  line-height: 16px;
  font-family: var(--font-family);
  color: #ffffff;
`;
